import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (idx) => {
      return _createElementVNode("div", {
        class: "tooltip-activator relative",
        key: idx
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([`bg-next-${_ctx.getColoriStati(idx-1)}`, "border rounded text-center text-xs font-bold text-white p-1"])
        }, _toDisplayString(_ctx.getTooltip(idx-1)), 3)
      ])
    }), 64))
  ]))
}